import { Button, List, Space, Typography } from "antd";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useDelete from "hooks/useDelete";
import useCreate from "hooks/useCreate";

import ModalDelete from "components/ModalDelete";
import { getIssueKindIcon } from "helpers/issue_kind_icons";

const Item = ({
  id,
  name,
  fa_icon_name,
  icon_type,
  refetch,
  icon_url,
  is_first,
  is_last,
  first_issue_kind_ref,
}) => {
  const navigate = useNavigate();

  const { is_deleting, _delete } = useDelete({
    path: `/issue_kinds/${id}`,
    onSuccess: refetch,
  });

  const { is_saving: is_saving_move_up, create: moveUp } = useCreate({
    path: `/issue_kinds/${id}/move_up`,
    onSuccess: refetch,
    success_message: "Przeniesiono w górę",
  });

  const { is_saving: is_saving_move_down, create: moveDown } = useCreate({
    path: `/issue_kinds/${id}/move_down`,
    onSuccess: refetch,
    success_message: "Przeniesiono w dół",
  });

  return (
    <List.Item
      className="issue-kind-list__item"
      actions={[
        <Button
          onClick={() => navigate(`/issue_kinds/${id}`)}
          type="primary"
          style={{ backgroundColor: "#1677ff" }}
          ref={is_first ? first_issue_kind_ref : null}
        >
          Edytuj
        </Button>,
        <Button
          loading={is_saving_move_up}
          disabled={is_first}
          onClick={() => moveUp()}
          type="primary"
          ghost
          icon={<UpOutlined />}
        />,
        <Button
          disabled={is_last}
          onClick={() => moveDown()}
          type="primary"
          ghost
          loading={is_saving_move_down}
          icon={<DownOutlined />}
        />,
        <ModalDelete
          loading={is_deleting}
          only_icon={true}
          text={`typ zgłoszenia "${name}"`}
          handleDelete={_delete}
        />,
      ]}
    >
      <Space className="item-name" align="center">
        <div className="issue-kind-icon-box">
          {icon_type === "fa_icon" ? (
            getIssueKindIcon(fa_icon_name)
          ) : (
            <img src={icon_url} alt="" />
          )}
        </div>
        <Typography.Title level={5} style={{ margin: "0 0 5px 5px" }}>
          {name}
        </Typography.Title>
      </Space>
    </List.Item>
  );
};

export default Item;
